<div class="ibox">
    <iboxtools *ngIf="toolboxEnabled"
        [Title]=""
        [isHistory]=true
        [DateInit]="datoOrganizativo?.desde"
        [DateEnd]="datoOrganizativo?.hasta"
        [PeriodList]="datosOrganizativosList"
        [IsEditing]="isEditing"
        (PeriodChange)="PeriodChange($event)"
        (NewChange)="NewChange($event)"
        (EditChange)="EditChange($event)"
        (SaveChange)="SaveChange($event)"
        (CutChange)="CutChange($event)"
        (DeleteChange)="DeleteChange($event)"
        (CancelChange)="CancelChange($event)"
        [onlyNew]="onlyNew"
        [Permiso]="permisoEdicion"
    ></iboxtools>
    <div class="ibox-content">
        <mat-error *ngIf="datosInvalida" class="datosInvalida">{{MensajeError}}</mat-error>
        <form [formGroup]="form" (ngSubmit)="save($event)">
            <div class="row" hidden="true">
                <input formControlName="id" name ="id" type="text" class="form-control" />
                <input formControlName="personal" name ="personal" type="text" class="form-control" />
            </div>
            <div class="row panel panel-warning" *ngIf="!disabledEditing">
                <div class="col-lg">
                    <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
                    <div class="col-lg-8" >
                        <p-calendar appendTo="body" selectOtherMonths="true"  formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl></p-calendar>
                        <div *ngIf="f.desde.errors?.required && (f.desde?.dirty || f.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
                        <mat-error *ngIf="f.desde.errors?.anteriorRetroactividad && (f.desde?.dirty || f.desde?.touched)" class="text-danger">
                            No puede ser anterior al límite de retroactividad {{gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
                        </mat-error>
                    </div>
                </div>
                <div class="col-lg">
                    <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
                    <div class="col-lg-8" >
                        <p-calendar appendTo="body" selectOtherMonths="true"  formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl></p-calendar>
                        <div *ngIf="f.hasta.errors?.required && (f.hasta?.dirty || f.hasta?.touched)"  class="text-danger">La Fecha es Requerida</div>
                        <mat-error  class="text-danger" *ngIf="f.hasta.errors?.fecHastaMenor && (f.hasta?.dirty || f.hasta?.touched)">
                            La Fecha no puede ser menor que la Fecha Desde
                        </mat-error>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg">
                    <label class="col-form-label font-bold">Sociedad</label>
                    <div>
                        <comboTools
                            [list]=sociedadesList
                            selected='sociedad'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion"
                            (SelectedChange)="onChangeSociedad($event)">
                        </comboTools>
                        <div *ngIf="f.sociedad.invalid && (f.sociedad?.dirty || f.sociedad?.touched)" class="text-danger">
                            <div *ngIf="f.sociedad.errors.required">La Sociedad es Requerida</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg">
                    <label class="col-form-label font-bold">Unidad Organizativa</label>
                    <comboTools
                            [list]=unidadesOrganizativasList
                            selected='unidadOrganizativa'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion">
                    </comboTools>
                    <div *ngIf="f.unidadOrganizativa.invalid && (f.unidadOrganizativa?.dirty || f.unidadOrganizativa?.touched)" class="text-danger">
                        <div *ngIf="f.unidadOrganizativa.errors.required">La Unidad Organizativa es Requerida</div>
                    </div>
                </div>
                <div class="col-lg">
                    <label class="col-form-label font-bold">Posición</label>
                    <comboTools
                            [list]=posicionesList
                            selected='posicion'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion">
                    </comboTools>
                    <div *ngIf="f.posicion.invalid && (f.posicion?.dirty || f.posicion?.touched)" class="text-danger">
                        <div *ngIf="f.posicion.errors.required">La Posición es Requerida</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg">
                    <label class="col-form-label font-bold">Sede</label>
                    <comboTools
                            [list]=sedesList
                            selected='sede'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion"
                            (SelectedChange)="onChangeSede($event)">
                    </comboTools>
                    <div *ngIf="f.sede.invalid && (f.sede?.dirty || f.sede?.touched)" class="text-danger">
                        <div *ngIf="f.sede.errors.required">La Sede es Requerida</div>
                    </div>
                </div>                    
                <div class="col-lg">
                    <label class="col-form-label font-bold">Subsede</label>
                    <comboTools
                            [list]=subSedesList
                            selected='subSede'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion">
                    </comboTools>
                    <div *ngIf="f.subSede.invalid && (f.subSede?.dirty || f.subSede?.touched)" class="text-danger">
                        <div *ngIf="f.subSede.errors.required">La Subsede es Requerida</div>
                    </div>
                </div>                    
            </div>
            
            <div class="row">
                <div class="col-lg">
                    <label class="col-form-label font-bold">Grupo Liquidación</label>
                    <comboTools
                            [list]=gruposLiquidacionList
                            selected='grupoLiquidacion'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion">
                    </comboTools>
                    <div *ngIf="f.grupoLiquidacion.invalid && (f.grupoLiquidacion?.dirty || f.grupoLiquidacion?.touched)" class="text-danger">
                        <div *ngIf="f.grupoLiquidacion.errors.required">El Grupo Liquidación es Requerido</div>
                    </div>
                </div>
                <div class="col-lg">
                    <label class="col-form-label font-bold">Grupo Personal</label>
                     <comboTools
                            [list]=gruposList
                            selected='grupoPersonal'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion"
                            (SelectedChange)="onChangeGrupo($event)"
                            ph= "Grupo Liquidación">
                    </comboTools>
                    <div *ngIf="f.grupoPersonal.invalid && (f.grupoPersonal?.dirty || f.grupoPersonal?.touched)" class="text-danger">
                        <div *ngIf="f.grupoPersonal.errors.required">El Grupo Personal es Requerido</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg">
                    <label class="col-form-label font-bold">SubGrupo Personal</label>
                    <comboTools
                            [list]=subGruposList
                            selected='subGrupoPersonal'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion">
                    </comboTools>
                    <div *ngIf="f.subGrupoPersonal.invalid && (f.subGrupoPersonal?.dirty || f.subGrupoPersonal?.touched)" class="text-danger">
                        <div *ngIf="f.subGrupoPersonal.errors.required">El SubGrupo Personal es Requerido</div>
                    </div>
                </div>
                <div class="col-lg">
                    <label class="col-form-label font-bold">Centro de Costo</label>
                    <comboTools
                            [list]=centrosCostosList
                            selected='centroCosto'
                            [formParent]="form"
                            [isEditing]=disabledEditing
                            filter="descripcion">
                    </comboTools>
                </div>
            </div>
        </form> 
    </div>
</div>
